import { NgModule } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { DEFAULT_LANGUAGE } from '@app/core/i18n/supported-languages';
import { localTranslateLoaderFactory } from './local-translate.loader';

@NgModule({
  imports: [
    TranslateModule.forRoot({
      defaultLanguage: DEFAULT_LANGUAGE,
      loader: {
        provide: TranslateLoader,
        useFactory: localTranslateLoaderFactory,
      },
    }),
  ],
  exports: [TranslateModule],
})
export class AppTranslateModule {}
